import { GlButton, GlCollapse } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
const HEADING_CLASSES = 'gl-mb-1 gl-text-xs gl-font-semibold gl-uppercase gl-tracking-wide gl-text-subtle';
export default {
    name: 'DecisionLogContext',
    components: {
        GlButton,
        GlCollapse
    },
    props: {
        context: {
            type: String,
            required: false,
            default: ''
        },
        rationale: {
            type: String,
            required: false,
            default: ''
        }
    },
    data () {
        return {
            isVisible: false
        };
    },
    computed: {
        toggleText () {
            return this.isVisible ? s__('WorkItemDecisionLog|Hide context') : s__('WorkItemDecisionLog|Show context');
        },
        toggleIcon () {
            return this.isVisible ? 'chevron-down' : 'chevron-right';
        }
    },
    methods: {
        toggle () {
            this.isVisible = !this.isVisible;
        }
    },
    headingClasses: HEADING_CLASSES
};
